import React from 'react'
import './card.css'

export const Card = ({
    id,
    children,
    isRounded,
    depth,
    onClick,
    style,
    className,
    ...rest
}: {
    id?: string;
    children: any,
    isRounded?: boolean,
    depth?: '0' | '1' | '2' | '3' | '4' | '5',
    onClick?: Function,
    style?: any,
    className?: string,
}) => {
    return (
        <div
            id={id}
            className={`card-${depth} ${className}`} style={{
                borderRadius: isRounded ? '8px' : 0,
                ...style
            }}
            // @ts-ignore
            onClick={onClick}
            {...rest}>
            {children}
        </div>
    )
}

Card.defaultProps = {
    isRounded: true,
    depth: '1'
}